var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAllocationsLightmode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 39C71 50.598 61.598 60 50 60C38.402 60 29 50.598 29 39C29 27.402 38.402 18 50 18C61.598 18 71 27.402 71 39Z",
    fill: "#000433"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62C56 73.598 46.598 83 35 83C23.402 83 14 73.598 14 62C14 50.402 23.402 41 35 41C46.598 41 56 50.402 56 62Z",
    fill: "#000433"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86 62C86 73.598 76.598 83 65 83C53.402 83 44 73.598 44 62C44 50.402 53.402 41 65 41C76.598 41 86 50.402 86 62Z",
    fill: "#FC3165"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAllocationsLightmode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/allocations-lightmode.1587cda43719e1f1d2e90ec10929c8fb.svg";